(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wmd-product-info"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => document.querySelectorAll('form.wmd-one-time-form').forEach(form => {
    if (form.dataset.wmdOneTimeReady) return;
    form.dataset.wmdOneTimeReady = 'true';
    let updating = false;
    const resetPlan = () => {
      if (updating) return;
      updating = true;
      try {
        const oneTime = form.querySelector('[data-radio-onetime]');
        if (oneTime && !oneTime.checked) oneTime.click();
        form.querySelectorAll('[name="selling_plan"]').forEach(input => {
          if (input.value) input.value = '';
          input.disabled = true;
        });
      } finally { updating = false; }
    };
    resetPlan();
    new MutationObserver(resetPlan).observe(form, {childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked']});
    form.addEventListener('submit', resetPlan, true);
    form.addEventListener('formdata', event => event.formData.delete('selling_plan'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
